import ENUMS_TRANSFORM from './transformToEnum';

function getSymbol(key, profitType) {
  const symbols = {
    breakEven: '%',
    profit: ENUMS_TRANSFORM.PROFIT_TYPES[profitType],
    minimalProfit: ENUMS_TRANSFORM.PROFIT_TYPES[profitType],
    optimalProfit: ENUMS_TRANSFORM.PROFIT_TYPES[profitType],
    maximalProfit: ENUMS_TRANSFORM.PROFIT_TYPES[profitType],
    profit_percent: '%',
    minimal_profit_percent: '%',
    minimal_profit_dollars: '$',
    maximal_profit_dollars: '$',
    optimal_profit_percent: '%',
    optimal_profit_dollars: '$',
    down_dollars: '$',
    up_dollars: '$',
    raise_amount: '$',
  };

  return symbols[key] || null;
}

export default getSymbol;
